import React from 'react'
import { motion } from 'framer-motion'
import { framer_desc, framer_icon, framer_title, framer_title2, framer_by_title } from './framer'
import scrollAnimation from './lottie_scroll.json'
import Lottie from 'lottie-react'

export const Hero = () => {
  return (
    <section className="relative flex flex-col justify-center flex-1 gap-8">
      <div className="absolute bg-contain w-[100%] top-0 -z-10 opacity-40 h-60 bg-hero-pattern-mobile md:hidden">
        <div className="bg-gradient-to-t from-midnight w-[100%] h-[100%]"></div>
      </div>
      <div className="absolute hidden bg-cover md:block -left-44 h-80 w-80 bg-illustration-hero-left lg:-left-20">
        <div className="bg-gradient-to-r from-midnight w-[100%] h-[100%]"></div>
      </div>
      <div className="absolute hidden bg-cover md:block -right-44 h-80 w-80 bg-illustration-hero-right lg:-right-20">
        <div className="bg-gradient-to-l from-midnight w-[100%] h-[100%]"></div>
      </div>
      <div className="flex flex-col items-center gap-8 p-5 md:max-w-[28.563rem] md:m-auto md:bg-bg-hero-squiggle md:bg-contain bg-no-repeat bg-center ">
        <motion.h1
          {...framer_title}
          className="text-3xl font-bold leading-snug text-center md:text-4xl"
        >
          Invest in Real Estate.
        </motion.h1>

        <motion.h2
          {...framer_title2}
          className="text-1xl font-bold leading-snug text-center md:text-2xl"
        >
          Powered by <span className="text-cyan-100">Web3</span>{' '}
          technology.
        </motion.h2>

        <motion.h1
        {...framer_by_title}
        className="text-3xl font-bold leading-snug text-center md:text-3xl">
         by CrowdStake
        </motion.h1>

        <motion.p {...framer_desc} className="text-1xl text-center text-gray">
          Connect, verify your identilty, invest, relax.
        </motion.p>
        <motion.a href="#showcase" className="max-w-[5rem]" {...framer_icon}>
          <Lottie animationData={scrollAnimation} loop={true} />
        </motion.a>
      </div>
    </section>
  )
}
